<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 8V5h2v3H8Zm0 9v-5h2v5H8Zm-2 5c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 6 2h12c.55 0 1.02.196 1.413.587C19.803 2.98 20 3.45 20 4v16c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 18 22H6Zm0-2h12v-9H6v9ZM6 9h12V4H6v5Z"
    />
  </svg>
</template>
